<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents" v-show="!isProcessing">
      <h1 class="l-pageTitle">メールアドレス確認完了</h1>
      <div class="l-contentsBox">
        <div class="l-infoDetail">
          <div class="l-infoDetail__body">
            <div class="l-infoDetail__box">
              <div class="l-infoDetail__text" v-if="this.isValid">
                <p>メールアドレスの確認が完了しました。</p>
                <p>お申込み内容確認後、メールにてご連絡いたします。</p>
              </div>

              <div class="l-infoDetail__text" v-else>
                <p>メールアドレスの確認ができませんでした。</p>
                <p>恐れ入りますが、再度お申込みください。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isProcessing: false,
      isValid: false,
    }
  },
  created: function() {
    let token = this.$route.query?.token;
    this.confirmToken(token);
  },
  methods: {
    async confirmToken(token) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/contact/contact_form/confirm_token', {
        token: token
      });
      if (res) {
        this.isValid = res.data.isValid;
      }
      this.isProcessing = false;
    }
  }
}

</script>